import { render, staticRenderFns } from "./search-to-add.vue?vue&type=template&id=37173f16&scoped=true&"
import script from "./search-to-add.vue?vue&type=script&lang=js&"
export * from "./search-to-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37173f16",
  null
  
)

export default component.exports